module.exports = __webpack_public_path__ + "static/img/noinfo.d4c5584.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/noinfo.png
// module id = ZRo/
// module chunks = 29